import React, { useEffect,useState } from "react";
import DateStep from "./DateStep";
import ResumeStep from "./ResumeStep";
import TransactionStep from "./TransactionStep";
import ProductType from "./ProductType";
import { Steps, useStepper } from "../../../components/Ui/Stepper";
import { useStore } from "_Store";
import Container from "components/Layout/Container";
import { Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { addStockData } from "services/stock.service";
import TransactionStep2 from "./TransactionStep2";

const steps = [
  {
    label: "Date",
    value:'date',
    element: DateStep,
  },
  {
    label: "Type d'Opération",
    value:'type_operation',
    element: TransactionStep,
  },
  {
    label: "Type de Produit",
    value:'type_produit',
    element: ProductType,
  },
  {
    label: "Informations sur la culture à stocker",
    value:'details',
    element: TransactionStep2,
  },
  {
    label: "Résumé",
    value:'resume',
    element: ResumeStep,
  }
];

const StockSteps = (props) => {
  const navigate = useNavigate();
  const { state, storeUser, setUtils, setTableDataResponse } = useStore();
  const { activeStep: step, handleNext, handleBack, handleToStart } = useStepper();
  const [dynamicSteps, manageSteps] = useState(steps);
  const allStepsCompleted = dynamicSteps === dynamicSteps.length;
  const isLastStep = dynamicSteps === dynamicSteps.length - 1;
  //const CurrentSetForm = dynamicSteps[step].element;

  const handleAddToSteps = async(newStep) => {
      const prevSteps = steps;
      manageSteps([...prevSteps.slice(0, 3), newStep, ...prevSteps.slice(3)]);  
  };

  const handleRemoveFromSteps = (valueToRemove) => {
    let data = dynamicSteps.filter((item) => {
      return item.value !== valueToRemove;
    });
    manageSteps(data);
  };

  const handleRemoveAllFromSteps = async () => {
    return new Promise((resolve) => {
      manageSteps(steps);
      resolve(); // Resolving the promise to signal completion
    });
  };
  const handleAddFormData = async (data, save) => {
    console.log(save,'ara you workin here now ?????*** ueiur pour *****')
    if (save) {
      console.log('save group owning ?*** ff *****')
      state.tableData.push({
        ...state.tableDataResponse,
        ...data,
      });
      const res = await addStockData({
        ...state.tableDataResponse,
        ...data,
      });
      console.log(res,'las step was init now **********')
      if (res.data.success) {
        setTableDataResponse({});
        navigate("/stock-sheet");
      }
    }
    if (!isLastStep) {
      setTableDataResponse({
        ...state.tableDataResponse,
        ...data,
      });
      handleNext();
    } else {
      console.log('las step was init now **********')
      setUtils("loading", { spinning: true, primary: "" });
      navigate("/stock-sheet");
      setTimeout(() => {
        setTableDataResponse({});
        //handleNext();
        setUtils("loading", { spinning: false, primary: "" });
      }, 1200);
    }
  };
  useEffect(() => {
    return () => {
      setTableDataResponse({});
    };
  }, []);

  const stepContainer = (WrapperComponent) => {
    return (
      <WrapperComponent
        onSubmit={(pl, save) => handleAddFormData(pl, save)}
        onBack={handleBack}
        onPrevToStart={handleToStart}
        addToSteps={handleAddToSteps}
        removeFromSteps={handleRemoveFromSteps}
        removeAllFromSteps={handleRemoveAllFromSteps}
      />
    );
  }; 

  return (
    <Container>
      <div className="sm:w-1/4 bg-white">
        <div className="flex flex-col h-full justify-center py-10 sm:py-0">
          {!allStepsCompleted ? (
            <div className="pl-4 sm:pl-12">
              <div className="py-4">
                <Typography>Etape {step + 1} sur {dynamicSteps.length}</Typography>
              </div>
              <Steps steps={dynamicSteps} />
            </div>
          ) : (
            <div className="flex flex-col h-full items-center sm:px-12 pt-24 pb-16"></div>
          )}
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        {step<=dynamicSteps.length ?  
        <div className="w-full ">
         { !allStepsCompleted && stepContainer(dynamicSteps[step]?.element) }
        </div>
        : null}
      </div>
      {/* {
        isLastStep && 'Ici on est chaud'
      } */}
    </Container>
  );
};
export default StockSteps;
